import React from 'react';
import { CgSpinnerAlt } from 'react-icons/cg';

export default function Spinner({ className }) {
  return <CgSpinnerAlt className={`animate-spin ${className}`} />;
}
